import { render, staticRenderFns } from "./Materiales.vue?vue&type=template&id=46e28a4b&scoped=true"
import script from "./Materiales.vue?vue&type=script&lang=js"
export * from "./Materiales.vue?vue&type=script&lang=js"
import style0 from "./Materiales.vue?vue&type=style&index=0&id=46e28a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e28a4b",
  null
  
)

export default component.exports